import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import VueAxios from "vue-axios";
import "./assets/css/golbao.css";
// 引入导出 的格式
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
//图片预览
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import dayjs from "dayjs"
Vue.prototype.$dayjs = dayjs;
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999, // 设置图片预览组件的层级，确保能在其他组件之上
    title: false, // 是否显示当前图片标题，默认显示alt属性内容和尺寸
  },
});

// 引入百度地图
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, { ak: "w1CPNlvtos3pvc7hqi6oZNmRs92SX8Al" });
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.use(ElementUI);

// 屏幕自适应穿透px为rem模板
const baseSize = 16; // 设计稿根字体大小
function setRem() {
  if (
    document.documentElement.clientWidth >= 762 &&
    document.documentElement.clientWidth <= 2040
  ) {
    const scale = document.documentElement.clientWidth / 1920; // 计算缩放比例
    document.documentElement.style.fontSize =
      baseSize * Math.min(scale, 2) + "px"; // 设置根字体大小
  }
  if (
    document.documentElement.clientWidth >= 300 &&
    document.documentElement.clientWidth <= 762
  ) {
    // const scale = (750) / 1920 // 计算缩放比例
    document.documentElement.style.fontSize = 62.5 + "%"; // 设置根字体大小
    // document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
  }
}

setRem();
window.addEventListener("resize", setRem); // 窗口大小改变时重新计算

new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
